// Helper function to keep the add button variant id in sync
(() => {
  function getVariants(card) {
    const script = card.querySelector(".variant-data");
    if (!script?.textContent) return [];

    try {
      return JSON.parse(script.textContent);
    } catch {
      return [];
    }
  }

  function syncVariantId(card, optionButton = card.querySelector(".opt-btn.active")) {
    const priceRow = card.querySelector(".price-row");
    if (!optionButton) return;

    const selectedValue = optionButton.getAttribute("data-value");
    const selectedVariant = getVariants(card).find((variant) => variant.option1 === selectedValue);
    if (!selectedVariant?.id) return;

    if (priceRow) priceRow.setAttribute("data-variant-id", selectedVariant.id);

    const addButton = card.querySelector(".add");
    if (addButton) addButton.setAttribute("data-id", selectedVariant.id);
  }

  function init() {
    document.querySelectorAll(".product-card").forEach(syncVariantId);
  }

  document.addEventListener("click", (event) => {
    const optionButton = event.target.closest(".product-card .opt-btn");
    if (!optionButton) return;

    const card = optionButton.closest(".product-card");
    if (!card) return;

    syncVariantId(card, optionButton);
    if (window.Abra && typeof window.Abra.render === "function") window.Abra.render();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
